import React from 'react';
import styles from './PlaceReviewText.module.scss';
import ShowMoreText from 'gui/components/showMoreText/ShowMoreText';
import {IPlaceDetailsReview} from "data/interfaces/products";


interface IHotelReview {
  review: Partial<IPlaceDetailsReview>;
}


const PlaceReviewText = (props: IHotelReview) => <ShowMoreText
  className={styles.content}
>
  {props.review.text}
</ShowMoreText>;

PlaceReviewText.defaultProps = {};

export default React.memo(PlaceReviewText);
